import React, { createContext, useContext, useState } from 'react';
import Api from '../utils/Api';
import { useAuth } from '../context/AuthContext';
import { useError } from '../context/ErrorContext';

const ChangePasswordContext = createContext(null);

export const ChangePasswordProvider = ({ children }) => {
  const [api, setApi] = useState(null);
  const { user, getToken } = useAuth();
  const { handleApiError, formErrors, clearErrors } = useError();

  // Initialize API with token getter
  React.useEffect(() => {
    setApi(Api(() => getToken()));
  }, [user, getToken]);

  const changePassword = async (passwordData) => {
    
      clearErrors();
      const response =  await api.call('change-password', 'POST', passwordData, true);
      
      if(response.status === 200){
        return {'status':response.status};
      }else{
 
        if(response.error.status === 422){
          return {'status':response.error.status,'errors':response.error.validationErrors};
          
        }else{
          return handleApiError(response.error, {
            showAlert: false,
            redirectOn401: true,
            customMessage: 'Failed to change password'
          });
        }
       
       
      }
       
  };

  return (
    <ChangePasswordContext.Provider value={{
      formErrors,
      clearErrors,
      changePassword
    }}>
      {children}
    </ChangePasswordContext.Provider>
  );
};

export const useChangePassword = () => {
  const context = useContext(ChangePasswordContext);
  if (!context) {
    throw new Error('useChangePassword must be used within a ChangePasswordProvider');
  }
  return context;
}; 